window.$ = window.jQuery = require('jquery')



// WEBPACK FOOTER //
// ./src/libs.js